// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { Button, Grid, Divider } from '@mui/material';
import { IconButton } from 'components/Buttons';
import MBDialog from 'components/Elements/MBDialog';
import MBSelect from 'components/Forms/MBSelect/MBSelect';
import TypographyComponent from 'components/Typography/Typography';
import { pxToEm } from 'theme';

export const Dialog = styled(MBDialog)`
  overflow-y: auto;
  & > .MuiBackdrop-root {
    background: rgba(0, 0, 0, 0.3);
  }
  .MuiDialog-container,
  &.MuiDialog-container {
    height: auto;
    margin-top: ${pxToEm(90)};
    margin-bottom: ${pxToEm(180)};
    & > .MuiPaper-root {
      max-width: 1000px !important;
      width: 100% !important;
      max-height: none;
      overflow: visible;
      border-radius: ${pxToEm(20)};
      padding: 0;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin-top: 0;
      margin-bottom: 0;
      & > .MuiPaper-root {
        border-radius: 0;
        max-height: 100vh;
        height: 100%;
        margin: 0;
        overflow-y: auto;
      }
    }
  }
  & .MuiDialogContent-root {
    overflow: visible;
    padding-top: 0;
  }
`;

export const ProductName = styled(TypographyComponent)`
  font-family: 'Graphik';
  font-style: normal;
  font-weight: 600;
  font-size: ${pxToEm(36)};
  line-height: 48px;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  letter-spacing: -0.02em;
`;

export const ProductInfoLabel = styled(TypographyComponent)`
  font-size: ${pxToEm(16)};
  line-height: 22px;
  color: ${({ theme }) => theme.palette.grey['A400']};
`;

export const ProductInfoValue = styled(TypographyComponent, {
  shouldForwardProp: (prop) => !['isDescription'].includes(String(prop)),
})<{ isDescription?: boolean }>`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: flex-start;
  color: ${({ theme }) => theme.palette.primary.main};
  ${({ isDescription }) => isDescription && 'display: inline-block'};
`;

export const BrandLabel = styled(TypographyComponent)`
  margin-bottom: ${pxToEm(4)};
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const LearnMoreButton = styled(Button)`
  margin-top: ${pxToEm(16)};
`;

export const ContactRepButtonWrapper = styled.div`
  position: relative;
  margin-left: ${pxToEm(8)};
`;

export const ContactRepPortal = styled.div`
  position: absolute;
  left: 0;
  bottom: -${pxToEm(12)};
`;

export const CloseIcon = styled(IconButton)`
  position: absolute;
  font-size: 1.125em;
  color: #4d4e58;
  top: 1em;
  right: 1em;
  z-index: 1;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[200]};
  }
`;

export const Select = styled(MBSelect)`
  max-width: ${pxToEm(146)};
  .MuiOutlinedInput-notchedOutline {
    border-width: 0px !important;
  }

  .MuiSelect-outlined.MuiOutlinedInput-input {
    min-width: ${pxToEm(15)};
    padding: 0 2em 0 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    display: block;
  }
  fieldset {
    opacity: 0;
  }
`;

export const ImageWrapper = styled.a`
  position: relative;
  flex: 0 0 ${pxToEm(250)};
  aspect-ratio: 1/1;
  height: 100%;
`;

export const OverlayImage = styled.div`
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: ${pxToEm(20)};
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 22;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  #RestrictedItemModal {
    height: auto;
    position: relative;
    overflow: hidden;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    #RestrictedItemModal {
      height: 100%;
      overflow-y: auto;
    }
  }
`;

// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const DescriptionWrapper = styled(Grid as any, {
  shouldForwardProp: (prop) => !['dataNumber'].includes(String(prop)),
})<{ dataNumber: number }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-width: ${({ dataNumber = 1 }) =>
    dataNumber ? `${100 / (dataNumber + 1)}%` : '15%'};
  max-width: ${({ dataNumber = 1 }) =>
    dataNumber ? `${100 / dataNumber}%` : '25%'};
  width: auto;
  &:not(:first-of-type) {
    padding-left: 0.75em;
  }
`;

export const ProjectSelector = styled.div`
  margin-left: auto;
  margin-right: 1em;
  margin-top: 1em;
  max-width: 200px;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    max-width: 250px;
  }
  width: auto;
  height: 48px;
  position: relative;
  & > *:first-of-type {
    position: relative;
    width: auto;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const DescriptionText = styled.div`
  width: 100%;
  margin-top: 1.5em;
`;

export const SampleNote = styled(TypographyComponent)`
  margin-top: 1.5em;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const Line = styled(Divider)`
  border-color: #f2f2f2;
`;

export const ContentContainer = styled.div`
  display: flex;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`;

export const Sidebar = styled.div`
  width: 250px;
  padding: 25px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-right: 1px solid #f5f5f7;
  flex-shrink: 0;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const MainContent = styled.div`
  padding: 25px;
  flex: 1;
  min-width: 0;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 16px;
    padding-top: 48px;
  }
`;

export const ModalTitle = styled.div`
  max-width: 90%;
  min-height: 100px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-height: auto;
    font-size: 24px;
    margin-bottom: 16px;
    & .MuiTypography-root {
      font-size: 24px;
    }
  }
`;

export const FinishesList = styled.div`
  .virtuoso-grid-list {
    list-style: none;
    margin: 0;
    width: 100%;
    align-content: flex-start;
    display: flex;
    flex-wrap: wrap;
  }
`;

export const ItemContainer = styled.li`
  flex: none;
  padding: 0;
  margin: 0;
  width: 233px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 50%;
    box-sizing: border-box;
  }
`;
